import { HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { PagedCollectionQuery, PagedCollectionQueryResult } from '../common/query/paged-collection-query';


export interface CnCodeItem {
    readonly id: number;
    readonly description: string;
    readonly code: string;
}

export class CnCodeQuery extends PagedCollectionQuery<CnCodeItem> { }

export class CnCodeQueryHandlerBase implements QueryHandler<CnCodeQuery, PagedCollectionQueryResult<CnCodeItem>> {
    private static Url = TaggedUrl.join('system/cn', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: CnCodeQuery): Promise<PagedCollectionQueryResult<CnCodeItem>> {
        const { data } = await this.http.get<PagedCollectionQueryResult<CnCodeItem>>(CnCodeQueryHandlerBase.Url, {
            params:  { ...query.params }
        });
        return {
            items: data.items.map(i => ({id: i.id, code: i.code, description: i.description})),
            totalItemsCount: data.totalItemsCount
        };
    }
}
